var map = {
	"./chitra.jpg": 97011,
	"./dharanisri.jpg": 72781,
	"./hemalatha.jpg": 28983,
	"./jagadeesan.jpg": 30501,
	"./kalpana.jpg": 59918,
	"./karthikeyan.jpg": 31985,
	"./kavitha.jpg": 98404,
	"./pyingkodi.jpg": 17352,
	"./rahunathan.jpg": 75442,
	"./sindhu.jpg": 27817,
	"./tamilarasi.jpg": 81299,
	"./vijayakumar.jpg": 80642
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24652;